export default __webpack_public_path__ + "static/media/internet-icon.a06fdf7d.svg";